<template>
    <div class="col-12 mt-2" v-show="travaContinuar == diagnostico.tela">
        <div class="">
            <div class="rounded row align-center justify-content-center border border-danger-subtle cursor-pointer" :class="diagnostico.descricao != 'true' ? 'notConfirmedBtn' : 'confirmedBtn'" @click="addPontuacao">
                <div class="col-12 d-flex flex-column align-items-center justify-content-center">
                    <label class="d-flex"><span class="font-18"> {{diagnostico.pergunta}}</span></label>
                    <span class="font-15 text-warning font-italic">{{diagnostico.nivel}} pontos</span>
                </div>
            </div>
            
            <div class="row align-center justify-content-center">
                <div class="col">
                    <div class="row mb-1">
                        <!-- <label><i class="fas fa-crown font-13 color-theme mr-1"></i><span class="font-15"> Preenchido por:</span></label> -->
                        <textarea type="text" class=" rounded form-control required mt-2" placeholder="Anotação opcional" maxlength="500" style="background-color: #222427 !important;" v-model="diagnostico.descricaoEstresse"/>  
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Diagnostico',
    props: ['diagnostico', 'index', 'travaContinuar'],
    methods: {
        addPontuacao : function () {
            this.$emit('addPontuacao', this.diagnostico)
        }
    }
}

</script>

<style scoped>

.confirmedBtn {
   background-color: rgba(47, 255, 64, 0.411) !important;
}
.notConfirmedBtn {
   background-color: rgba(253, 47, 47, 0.479) !important;
}

</style>